export default __webpack_public_path__ + "static/media/1.a1ce133f.jpg";